import connectionFail from './connectionFail'

function install (Vue) {
  Object.defineProperty(Vue.prototype, '$connectionfail', {
    get () {
      let div = document.createElement('div')
      document.body.appendChild(div)
      return function (show, reload) {
        const Constructor = Vue.extend(connectionFail)
        new Constructor({
          data () {
            return {
              show: show
            }
          },
          methods: {
            reload: reload
          }
        }).$mount(div)
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/components/emptypage/connectionFail/index.js